<template>
  <section class="content mt-5">
    <mdb-container>
      <mdb-row>
        <mdb-col col="12" md="8" offset-md="2">
          <div class="form-logo text-center mb-5">
            <router-link :to="{ name: 'top' }">
              <img src="@/assets/images/waaarp_logo_bk.png" />
            </router-link>
          </div>
          <mdb-card>
            <mdb-card-body class="mx-4">
              <div class="text-center py-2">
                <mdb-card-text class="mb-0">登録したメールアドレスを入力し、送信ボタンを押してください。</mdb-card-text>
                <mdb-card-text>入力したメールアドレスにパスワード再設定メールが通知されます。</mdb-card-text>
              </div>
              <validation-observer v-slot="{ handleSubmit }">
                <form novalidate @submit.prevent="() => { validated = true; handleSubmit(submit) }" class="secondary-form">
                  <validation-provider name="メールアドレス" rules="required|email" v-slot="{ errors }">
                    <custom-mdb-input
                      class="my-5"
                      label="メールアドレス"
                      name="email"
                      type="email"
                      icon="envelope"
                      v-model="email"
                      :customValidation="validated && errors.length != 0"
                      :isValid="errors.length == 0"
                      :invalidFeedback="errors[0]"
                    />
                  </validation-provider>
                  <div class="text-center my-3">
                    <mdb-btn rounded color="primary" type="submit" :class="{ 'disabled': httpRequesting }">
                      <span v-if="httpRequesting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      メール送信
                    </mdb-btn>
                  </div>
                </form>
              </validation-observer>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
    </mdb-container>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ForgotPassword',
  data () {
    return {
      email: '',
      validated: false
    }
  },
  computed: {
    ...mapGetters({
      httpSuccess: 'httpSuccess',
      httpRequesting: 'httpRequesting'
    })
  },
  methods: {
    async submit() {
      await this.forgotPassword({
        email: this.email
      })
      if (this.httpSuccess) {
        this.$router.push({ name: 'top' })
      }
    },
    ...mapActions({
      forgotPassword: 'auth/forgotPassword'
    })
  }
}
</script>
